import { Direction, Tab, Tabs, Typography, Theme, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { getApplicationDirection } from '../global.app.slice';
import {
  CcfBox,
  CcfDashboardIcon,
  CcfHeader,
  CcfTabs,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './ccf-reporting.module.scss';
import CcfProductivity from './ccf-productivity/ccf-productivity';
import CcfPerformance from './ccf-performance/ccf-performance';

/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
      style={{ marginTop: '10px' }}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
/* eslint-disable-next-line */
export interface CcfReportingProps {}
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
function a11yProps(index: any) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #dae2e8',
    boxShadow: '0px 1px 3px #00000029',
    borderRadius: '5px',
  },
  buttonActive: {
    '&.Mui-selected': {
      color: '#005C99',
    },
  },

  appSpaceHeader: {
    background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
    borderRadius: '5px 5px 0px 0px',
    opacity: 1,
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: '7px',
    paddingBottom: '10px',
    paddingLeft: '5px',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginTop: '0px !important',
    '& section': {
      marginBottom: '0px !important',
      alignItems: 'flex-start',
      width: '100%',
    },
    '& > div': {
      marginTop: '0px !important',
      width: '100%',
    },
    '& label': {
      color: theme.palette.text.secondary,
      marginLeft: '4px !important',
      marginTop: '4px !important',
      fontWeight: 'bold',
      lineHeight: '1',
    },
    '& svg': {
      height: '20px',
      width: '20px',
    },
  },
}));
/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
export function CcfReporting(props: CcfReportingProps) {
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const classes = useStyles();
  const reportingTabs = [
    {
      element: <CcfProductivity />,
      tooltip: translate('productivity'),
      isActive: true,
      menuName: translate('productivity'),
    },
    {
      element: <CcfPerformance />,
      tooltip: translate('performance'),
      isActive: false,
      menuName: translate('performance'),
    },
  ];
  const [currentTab, setCurrentTab] = useState(0);

  /**
   * Used to update the app space tab menuName and tab index
   * @param newTabIndex - number
   * @example - handleChange(0)
   */
  const handleChange = (newTabIndex: number) => {
    setCurrentTab(newTabIndex);
  };

  return (
    <CcfBox className={classes.root}>
      <div className={classes.appSpaceHeader}>
        <CcfHeader
          LeftIcon={<CcfDashboardIcon />}
          headerText={translate('Reporting')}
          RightIcon
          direction={appDirection}
        ></CcfHeader>

        <CcfTabs
          currentTab={currentTab}
          // textColor={'#005C99'}
          variant={CcfTabs.Variant.STANDARD}
          setCurrentTab={handleChange}
          classes={{
            root: styles.tabsContainer,
            indicator: styles.activeTabIndicator,
          }}
          id={`agent_Reporting_${currentTab}_tab`}
        >
          {reportingTabs.map((tab, index) => (
            <CcfTabs.TabPanel key={index} label={tab.menuName}>
              <Box
                id={`agent_Reporting_${tab.element}_tab`}
                className={styles.tabLabel}
              >
                {tab.element}
              </Box>
            </CcfTabs.TabPanel>
          ))}
        </CcfTabs>
      </div>
    </CcfBox>
  );
}

export default CcfReporting;
